<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.staff') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.staff') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <el-button type="primary" size="small" round @click="createNew">{{ $t('staff.create') }}</el-button>
              </div>
              <el-input :placeholder="$t('staff.search-ph')" v-model="keyword" class="input-with-select" style="width:300px">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="card-body">
              <el-table
                ref="filterTable"
                :data="staff.filter(data => !keyword || data.eName.toLowerCase().includes(keyword.toLowerCase()) || data.cName.includes(keyword))"
                style="width: 100%"
                @row-click="editProfile">
                <el-table-column
                  prop="eName"
                  :label="$t('profile.e-name')"
                  sortable
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="cName"
                  :label="$t('profile.c-name')"
                  sortable
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="onboardDate"
                  sortable
                  :label="$t('profile.onboard')"
                  width="120"
                  >
                </el-table-column>
                <el-table-column
                  prop="teamName"
                  sortable
                  :label="$t('profile.team')"
                  :filters="teamFilters"
                    :filter-method="filterTeam"
                    column-key="teamName"
                  >
                </el-table-column>
                <el-table-column
                  prop="practiceName"
                  sortable
                  :label="$t('profile.practice')"
                  :filters="practiceFilters"
                    :filter-method="filterPractice"
                    column-key="pacticeName"
                  >
                </el-table-column>
                <el-table-column
                  prop="levelName"
                  sortable
                  :label="$t('profile.level')"
                  :filters="levelFilters"
                    :filter-method="filterLevel"
                    column-key="levelName"
                    width="100"
                  >
                </el-table-column>
                <el-table-column
                  prop="eTitle"
                  :label="$t('profile.title')"
                  sortable
                  >
                </el-table-column>
                <el-table-column
                  prop="userTypeName"
                  :label="$t('profile.user-type')"
                  sortable
                  width="120"
                  :filters="userTypeFilters"
                    :filter-method="filterUserType"
                    column-key="userTypeName"
                  >
                </el-table-column>
                <el-table-column
                  prop="legalEntity"
                  :label="$t('profile.le')"
                  sortable
                  :filters="legalEntityFilters"
                    :filter-method="filterLegalEntity"
                    column-key="teamName"
                  >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <el-dialog :title="$t('profile.oc')" 
      :visible.sync="showOC"
      width="90%"
      top="30px"
      :append-to-body="true">
      <el-scrollbar>
              <OC :team="currentTeam" ref="oc-chart" />
            </el-scrollbar>
            <div slot="footer" class="dialog-footer">
          <el-button @click="showOC = false">{{ $t('profile.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OC from '@/components/profile/OC.vue'

export default {
  name: 'StaffList',
  components: {
    OC
  },
  data: function() {
  return {
    staff: [],
    keyword: null,
    showOC: false,
    currentTeam: null
  }
  },
  computed: {
    teamFilters: function() {
    let filter = this.team,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
  },
  practiceFilters: function() {
    let filter = this.practice,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
  },
    levelFilters: function() {
      let filter = this.level,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
    },
    legalEntityFilters: function() {
      let filter = this.legalEntity,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
    },
    userTypeFilters: function() {
      let filter = this.userType,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
    }
  },
  methods: {
    filterLegalEntity: function(value, row) {
      return row.legalEntityId === value
    },
    filterUserType: function(value, row) {
      return row.userType === value
    },
    filterTeam: function(value, row) {
      return row.team === value
    },
    filterPractice: function(value, row) {
      return row.practice === value
    },
    filterLevel: function(value, row) {
      return row.level === value
    },
    filterStaff: function() {

    },
    editProfile: function(row, column, event) {
      //console.log(column)
      if (column.columnKey == 'teamName') {
        this.currentTeam = row.team
        this.showOC = true
      } else {
        this.$router.push({ path: '/profile/' + row.id })
      }
    },
    createNew: function() {
      this.$router.push({ path: '/staff/new' })
    },
    loadData: function() {
      let that = this

    this.$http.get(this.API3_PREFIX + 'staff').then(function (response) {
    that.staff = response.data
    that.staff.forEach(function(v) {
      if (v.team != null)
        v.teamName = that.getTeam(v.team)
      if (v.practiceId != null)
        v.practiceName = that.getPractice(v.practiceId)
      if (v.level != null)
        v.levelName = that.$i18n.locale === 'zh' ? that.getLevelObj(v.level).c_name : that.getLevelObj(v.level).e_name
      if (v.legalEntityId != null)
        v.legalEntity = that.getLegalEntity(v.legalEntityId)
      if (v.userType != null)
        v.userTypeName = that.getUserType(v.userType)
    })
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>